export class Group {
    id: number;
    displayName: string;
    description: string;
    azureGuid: string
}
